import { useRef } from "react";
import { motion, useScroll, useTransform, useSpring } from "framer-motion";

export const reveal3d = {
  initial: { opacity: 0, y: 48, rotateX: 22, scale: 0.94 },
  whileInView: { opacity: 1, y: 0, rotateX: 0, scale: 1 },
  viewport: { once: true, amount: 0.2 },
  transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] },
  style: { transformPerspective: 1200, transformOrigin: "50% 100%" },
};

export const Reveal3D = ({ children, className, delay = 0, ...rest }) => (
  <motion.div
    {...reveal3d}
    transition={{ ...reveal3d.transition, delay }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Tilt3D = ({ children, className, strength = 10, ...rest }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const raw = useTransform(scrollYProgress, [0, 0.5, 1], [strength, 0, -strength]);
  const rotateX = useSpring(raw, { stiffness: 80, damping: 20 });
  const y = useTransform(scrollYProgress, [0, 1], [30, -30]);
  return (
    <motion.div
      ref={ref}
      style={{ rotateX, y, transformPerspective: 1400, transformStyle: "preserve-3d", willChange: "transform" }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
};
